<div class="gb-dialog-header">
  <h1 translate="USER_ACCOUNTS.CAMPAIGNS"></h1>
  <button mat-icon-button mat-dialog-close>
    <gb-icon icon="close"></gb-icon>
  </button>
</div>

<div class="gb-dialog-content">
  <div class="campaign-list-container">
    @for (campaign of campaigns; track campaign) {
      <div class="campaign-block" (click)="goToCampaign(campaign.url_name, $event); $event.stopPropagation()">
        <div class="campaign-label">
          <span class="name">{{ campaign.name }}</span>
          <span class="url">/{{ campaign.url_name }}</span>
        </div>
        <button mat-icon-button>
          <gb-icon height="20px" [icon]="'chevron-forward'"></gb-icon>
        </button>
      </div>
    }
  </div>
</div>
